<template>
  <div>
    <p>
      To: {{bindContactPerson()}} <br />
      <strong>{{ getAgentName() }}</strong> <br />
      <span v-html="bindInfo()"></span>
    </p>
  </div>
</template>
<script>
import { get } from 'lodash'
export default {
  name: 'ContactPerson',
  props: {
    agent: {
      contactPerson: {},
      id: '',
      information: {},
      name: ''
    }
  },
  methods: {
    getAgentName: function () {
      const agentName = get(this.agent, 'name', '-')

      return agentName
    },
    bindContactPerson: function () {
      const title = get(this.agent, 'contactPerson.title', '')
      const firstName = get(this.agent, 'contactPerson.firstName', '')
      const lastName = get(this.agent, 'contactPerson.lastName', '')
      const position = get(this.agent, 'contactPerson.position', '')
      const positionStr = (position === '') ? '' : `(${position})`
      return `${title} ${firstName} ${lastName} ${positionStr}`
    },
    bindInfo: function () {
      const contactPerson = get(this.agent, 'contactPerson', {})
      const contactPersonEmailList = get(contactPerson, 'emailList', [])
      const mobileList = get(contactPerson, 'mobileList', [])
      const contactPersonPhone = get(contactPerson, 'phone', '')
      const contactPersonFax = get(contactPerson, 'fax', '')
      const contactPersonMobileList = [ ...mobileList ]

      if (contactPersonPhone !== '') {
        contactPersonMobileList.push(contactPersonPhone)
      }

      const agentInfo = get(this.agent, 'information', {})
      const agentEmailList = get(agentInfo, 'emailList', [])
      const agentPhoneList = get(agentInfo, 'phoneList', [])
      const agentFaxList = get(agentInfo, 'faxList', [])

      const address = get(agentInfo, 'address', '')
      const country = get(agentInfo, 'country', '')
      const zipCode = get(agentInfo, 'zipCode', '')
      const fullAddress = `${address} ${country} ${zipCode}`

      const emailList = (contactPersonEmailList.length > 0) ? contactPersonEmailList : agentEmailList
      const phoneList = (contactPersonMobileList.length > 0) ? contactPersonMobileList : agentPhoneList
      const faxList = (contactPersonFax !== '') ? [ contactPersonFax ] : agentFaxList

      const emailStr = (emailList.length > 0) ? emailList.join(', ') : '-'
      const phoneStr = (phoneList.length > 0) ? phoneList.join(', ') : '-'
      const faxStr = (faxList.length > 0) ? faxList.join(', ') : '-'

      return `${fullAddress} <br>Tel: ${phoneStr} <br>Email: ${emailStr} <br>Fax: ${faxStr}`
    }
  }
}
</script>
